var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.navegavel ? "button" : "div",
    {
      tag: "component",
      staticClass: "ia-cliente-cabecalho",
      class: { "ia-cliente-cabecalho--navegavel": _vm.navegavel },
      attrs: { type: _vm.navegavel ? "button" : null },
      on: { click: _vm.aoClicar }
    },
    [
      _c(
        "span",
        { staticClass: "ia-cliente-cabecalho__rotulo ia-texto-selo" },
        [
          _c("span", [_vm._v("Perfil do cliente")]),
          _vm.navegavel
            ? _c("icon-svg", {
                attrs: {
                  name: "arrow-left",
                  size: _vm.TAMANHO_CHEVRON,
                  color: "var(--neutral-600)"
                }
              })
            : _vm._e(),
          _vm.selo
            ? _c("BaseStatus", {
                staticClass: "ia-cliente-cabecalho__selo",
                attrs: {
                  soft: "",
                  content: _vm.selo.texto,
                  color: _vm.selo.cor
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "ia-cliente-cabecalho__nome ia-texto-titulo-cartao",
          attrs: { title: _vm.nome }
        },
        [_vm._v(_vm._s(_vm.nome))]
      ),
      _vm.detalhe
        ? _c(
            "span",
            { staticClass: "ia-cliente-cabecalho__detalhe ia-texto-auxiliar" },
            [_vm._v(" " + _vm._s(_vm.detalhe) + " ")]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }